// ** React Imports
import { useState, useEffect, SyntheticEvent, useRef } from 'react'

import appInfo from '../../../../configs/app-info';

import Box from '@mui/material/Box'
import CardHeader from '@mui/material/CardHeader'
import Button from '@mui/material/Button'
import CardContent from '@mui/material/CardContent'
import Grid from '@mui/material/Grid';
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import {
    Divider,
    IconButton,
    Tooltip,
    Autocomplete,
    Fab,
    Typography,
    DialogActions,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText
} from '@mui/material'
import { useNavigate } from "react-router-dom";
import axios from 'axios'
import Swal from 'sweetalert2'
import { Controller, useForm } from 'react-hook-form'

import Icon from '../../../../components/icon';
import apiUrl from '../../../../configs/constant';
import MsiDatagrid from '../../../../components/custom/MsiDatagridAuto';

import moment from 'moment'
import Tab from '@mui/material/Tab'
import TabList from '@mui/lab/TabList'
import TabPanel from '@mui/lab/TabPanel'
import TabContext from '@mui/lab/TabContext'

import { getDoctag } from '../../../../api/helper';

import TableRowsPenggunaanBarang from '../../../../components/mm/penggunaan-barang/TableRowsPenggunaanBarang';

export default function Index() {
    const navigate = useNavigate();

    // ** State
    const [nik, setNik] = useState("");
    const [wo, setWo] = useState("");
    const [woProses, setWoProses] = useState("");

    const [rowsData, setRowsData] = useState<any[]>([]);
    const [listDaftarBarang, setListDaftarBarang] = useState<any[]>([])
    const [valBarang, setValBarang] = useState<any>(null)
    const [isDetail, setIsDetail] = useState<boolean>(false)

    const [inputQty, setInputQty] = useState<any>('')
    const [idBarang, setIdBarang] = useState<any>('')
    const [inputNamaBarang, setInputNamaBarang] = useState<string>('')
    const [inputStock, setInputStock] = useState<any>('')

    const [listBarang, setListBarang] = useState<any[]>([])
    const [detailBarang, setDetailBarang] = useState<any[]>([])

    useEffect(() => {
        // Ambil dari localStorage
        const storedNik = localStorage.getItem("NIK") || "-";
        const storedWo = localStorage.getItem("WO") || "-";
        const storedWoProses = localStorage.getItem("wo_proses_id") || "-";


        setNik(storedNik);
        setWo(storedWo);
        setWoProses(storedWoProses)
    }, []);



    const handleChangeAutocomplete = (event: SyntheticEvent, newValue: any | null) => {
        if (newValue != null) {
            setIdBarang(newValue?.id)
            setInputNamaBarang(newValue?.nama)
            setInputStock(newValue?.Stok)
            setOpenQty(true)
            setValBarang(newValue)
        }
    }


    interface FormInputs {
        no_spk: string
        pic_request: string
        wo_mesin_id: string
        dataDetail: any
    }

    const defaultValues = {
        wo_mesin_id: ''
    }

    // ** Hooks
    const {
        control,
        handleSubmit,
        setValue,
        formState: { errors }
    } = useForm<FormInputs>({ defaultValues })


    // handle dialog Qty
    const [openQty, setOpenQty] = useState<boolean>(false)
    const handleClickOpenQty = async (param: any) => {
        setIdBarang(param.id)
        setInputNamaBarang(param.nama)
        setOpenQty(true)
    }
    const handleCloseQty = () => {
        setOpenQty(false)
    }

    const handleKeyDown = (event: any) => {
        if (event.key === 'Enter') {
            handleTambahQty()
            event.preventDefault()
        }
    }

    const handleTambahQty = () => {
        setValBarang(null)
        if (rowsData.length == 0) {
            addTableRows()
            setOpenQty(false)
            setInputQty('')
            setIsDetail(false)
        } else {
            if (rowsData.some((item: any) => item.mmbarang_id === idBarang)) {
                alert('Barang telah dipilih')
            } else {
                addTableRows()
                setOpenQty(false)
                setInputQty('')
                setIsDetail(false)
            }
        }
    }


    const handleClickDetailTrue = async (params: any) => {
        setIsDetail(true)
        // let url = apiUrl.apiUrl + '/api/produksi/penggunaan-teknik/list-barang-teknik?jenis_teknik=' + params
        // axios
        //   .get(url, {
        //     headers: { Authorization: `Bearer ${token}` }
        //   })
        //   .then(response => {
        //     if (!response.data.success) {
        //       Swal.fire({
        //         title: 'Pemberitahuan',
        //         html: response.data.message,
        //         icon: 'error',
        //         willClose: () => {
        //           router.push('/barang-teknik/penggunaan-barang')
        //         }
        //       })
        //     } else {
        //       const data = response.data.data
        //       setDetailBarang(data)
        //     }
        //   })
        //   .catch(error => {
        //     Swal.fire({
        //       title: 'Pemberitahuan',
        //       text: error.message,
        //       icon: 'error'
        //     })
        //   })
    }

    const handleClickDetailFalse = () => {
        setIsDetail(false)
        // setRequiredQty(false)
    }

    const addTableRows = () => {
        const rowsInput = {
            id: '',
            mmbarang_id: idBarang,
            nama_barang: inputNamaBarang,
            qty: inputQty,
            stok: inputStock,
        }
        setRowsData([...rowsData, rowsInput])
    }

    const deleteTableRows = (index: any) => {
        const rows = [...rowsData]
        rows.splice(index, 1)
        setRowsData(rows)
    }

    const handleTable = (index: any, evnt: any) => {
        const { name, value } = evnt.target
        const rowsInput = [...rowsData]
        rowsInput[index][name] = value
        setRowsData(rowsInput)
    }

    // setValue('dataDetail', JSON.stringify(rowsData))
    setValue('dataDetail', JSON.stringify(rowsData))

    // SUBMIT
    const onSubmit = (data: any) => {
        // Swal.fire({
        //   title: 'Konfirmasi',
        //   text: 'Apakah anda ingin menyimpan data ini ?',
        //   icon: 'question',
        //   showCancelButton: true,
        //   confirmButtonColor: '#337ab7',
        //   cancelButtonColor: '#ffc107',
        //   confirmButtonText: 'Simpan'
        // }).then(result => {
        //   if (result.isConfirmed) {
        //     Swal.fire({
        //       title: 'Now loading',
        //       allowEscapeKey: false,
        //       allowOutsideClick: false,
        //       didOpen: () => {
        //         Swal.showLoading()
        //       }
        //     })

        //     const url = apiUrl.apiUrl + '/api/produksi/penggunaan-teknik/save'
        //     axios
        //       .post(url, data, {
        //         headers: { Authorization: `Bearer ${token}` }
        //       })
        //       .then(response => {
        //         if (response.data.success) {
        //           Swal.fire({
        //             title: 'Pemberitahuan',
        //             text: response.data.message,
        //             icon: 'success',
        //             timer: 1000,
        //             timerProgressBar: true,
        //             willClose: () => {
        //               const idNota = response.data.data
        //               let url = apiUrl.apiUrl + '/produksi/penggunaan-teknik/cetak-nota/' + idNota
        //               window.open(url, '_blank', 'location=yes,height=570,width=520,scrollbars=yes,status=yes')
        //               navigate('/mm/penggunaan-barang/')
        //             }
        //           })
        //         } else {
        //           Swal.fire({
        //             title: 'Pemberitahuan',
        //             text: response.data.message,
        //             icon: 'error'
        //           })
        //         }
        //       })
        //       .catch(error => {
        //         Swal.fire({
        //           title: 'Pemberitahuan',
        //           text: error.message,
        //           icon: 'error'
        //         })
        //       })
        //   }
        // })
    }

    const stockKosong = rowsData.some(row => Number(row.stok) === 0)

    return (
        <Grid container spacing={1} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xs={12} sm={12}>
                <Fab variant='extended' color='primary' sx={{ '& svg': { mr: 1 } }} onClick={() => window.history.back()}>
                    <Icon icon='mdi:arrow-left' />
                    Kembali
                </Fab>
                <div className="content-block dx-card" style={{ borderRadius: 10 }}>
                    <CardContent sx={{ display: "flex", justifyContent: "space-between" }}>
                        <Typography variant="h6">NIK : {nik}</Typography>
                        <Typography variant="h6">WO : {wo}</Typography>
                        <Typography variant="h6"></Typography>
                    </CardContent>
                </div>
            </Grid>
            <Grid item xs={12} sm={6} sx={{ marginBottom: 100 }}>
                <div className="content-block dx-card" style={{ borderRadius: 10 }}>
                    <CardHeader title='Daftar Barang' />
                    <FormControl sx={{ px: 2 }} fullWidth>
                        <Autocomplete
                            value={valBarang}
                            options={listDaftarBarang}
                            id='Sparepart'
                            isOptionEqualToValue={(option, value) => option.id === value.id}
                            onChange={handleChangeAutocomplete}
                            renderOption={(props, option) => {
                                return (
                                    <li {...props} key={option.id}>
                                        {option.nama}
                                    </li>
                                )
                            }}
                            getOptionLabel={option => option.nama}
                            renderInput={params => <TextField {...params} label='Cari Barang' />}
                        />
                    </FormControl>
                    <CardContent sx={{ display: "flex", justifyContent: "flex-start" }}>
                        {isDetail ? (
                            <>
                                <div onClick={handleClickDetailFalse}>
                                    <Fab color='primary' sx={{ mb: 3 }} size='small'>
                                        <IconButton
                                            sx={{
                                                color: 'primary'
                                            }}
                                        >
                                            <Icon icon='mdi:arrow-left' fontSize={24} color='white' />
                                        </IconButton>
                                    </Fab>
                                </div>
                                <Grid container spacing={6} sx={{ alignItems: 'center', justifyContent: 'center' }}>
                                    {detailBarang.map((item: any, index: any) => (
                                        <Grid item xs={12} sm={6} key={index}>
                                            <div onClick={() => handleClickOpenQty(item)} style={{ cursor: 'pointer' }}>
                                                <Box
                                                    sx={{
                                                        p: 2,
                                                        border: '1px solid grey',
                                                        borderRadius: 0.8,
                                                        flex: 1,
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        alignItems: 'center',
                                                        justifyContent: 'center'
                                                    }}
                                                >
                                                    <Typography variant='button'>{item.nama}</Typography>
                                                    <Typography variant='body2'>
                                                        Stok : {item.Stok} {item.Satuan}
                                                    </Typography>
                                                </Box>
                                            </div>
                                        </Grid>
                                    ))}
                                </Grid>
                            </>
                        ) : (
                            <>
                                <Grid container spacing={6} sx={{ alignItems: 'center', justifyContent: 'center' }}>
                                    {listBarang.map((item: any, index: any) => (
                                        <Grid item xs={6} sm={6} key={index}>
                                            <div onClick={() => handleClickDetailTrue(item.jenis_teknik)} style={{ cursor: 'pointer' }}>
                                                <Box
                                                    sx={{
                                                        p: 2,
                                                        border: '1px solid grey',
                                                        borderRadius: 0.8,
                                                        flex: 1,
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        backgroundColor: `${item.bg_hex}`
                                                    }}
                                                >
                                                    <Typography variant='h6' sx={{ color: `${item.font_hex}` }}>
                                                        {item.jenis_teknik}
                                                    </Typography>
                                                </Box>
                                            </div>
                                        </Grid>
                                    ))}
                                </Grid>
                            </>
                        )}
                    </CardContent>
                </div>
            </Grid>
            <Grid item xs={12} sm={6}>
                <div className="content-block dx-card" style={{ borderRadius: 10 }}>
                    <CardHeader title='Daftar Permintaan' />
                    <CardContent sx={{ display: "flex", justifyContent: "flex-start" }}>
                        <Grid container spacing={6} sx={{ alignItems: 'center', justifyContent: 'center' }}>
                            <Grid item xs={12} sm={12}>
                                <table className='table'>
                                    <thead>
                                        <TableRowsPenggunaanBarang
                                            rowsData={rowsData}
                                            deleteTableRows={deleteTableRows}
                                            handleTable={handleTable}
                                        />
                                    </thead>
                                </table>
                            </Grid>
                        </Grid>
                    </CardContent>
                </div>
            </Grid>
            <Dialog
                maxWidth={'xs'}
                fullWidth={true}
                open={openQty}
                onClose={handleCloseQty}
                aria-labelledby='form-dialog-title'
            >
                <DialogTitle id='form-dialog-title' sx={{ color: '#212121' }}>Quantity</DialogTitle>
                <DialogContent sx={{ color: '#212121' }}>
                    <DialogContentText sx={{ mb: 3 }}>Masukkan Quantity</DialogContentText>
                    <TextField
                        id='qty'
                        autoFocus
                        fullWidth
                        type='number'
                        onChange={e => setInputQty(e.target.value)}
                        label='Quantity'
                        onKeyDown={handleKeyDown}
                    />
                </DialogContent>
                <DialogActions className='dialog-actions-dense'>
                    <Button onClick={handleCloseQty}>Batal</Button>
                    <Button variant='contained' onClick={handleTambahQty} disabled={inputQty}>
                        Tambah
                    </Button>
                </DialogActions>
            </Dialog>
        </Grid>
    )
}
